import { useMutation } from '@tanstack/react-query';
import type { AgentApiInvitationsShow } from '@/types/serializers';

export default function useUpdateInvitationsInfo(token: string) {
  return useMutation({
    mutationFn: async (params: { name: string; password: string; password_confirm: string }) => {
      const response = await fetch(`/account/api/invitations/${token}`, {
        method: 'PUT',
        body: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error('Failed to update invitation info');
      }
      const updatedData: AgentApiInvitationsShow = await response.json();
      return updatedData;
    },
  });
}
